import { Directive, AfterViewInit, OnChanges } from "@angular/core";
import {
	Input,
	Output,
	EventEmitter,
	ElementRef,
	HostListener,
} from "@angular/core";
@Directive({
	selector: "[appImageButton]",
})
export class ImageButtonDirective implements OnChanges, AfterViewInit {
	@Input() buttonData: any;
	// @Input() disabled: boolean;
	@Input() useMouseAction?: Boolean;
	@Input() bgColor?: string;
	@Input() currentState?: string;
	@Output() buttonclick: EventEmitter<any> = new EventEmitter<any>();
	private el: HTMLElement;

	constructor(private elementRef: ElementRef) {
		console.log("ImageButtonDirective");
		this.el = elementRef.nativeElement;
	}
	ngOnChanges(changes) {
		if (changes.currentState) {
			if (changes.currentState.currentValue == "_visited") {
				this.currentState = "_visited";
				this.changeBg(this.currentState);
			} else if (changes.currentState.currentValue == "_active") {
				this.currentState = "_active";
				this.changeBg(this.currentState);
			} else if (changes.currentState.currentValue == "normal") {
				this.currentState = "normal";
				this.changeBg(this.currentState);
			}
		}
	}
	ngAfterViewInit() {
		if (!this.el) return;
		this.currentState =
			this.currentState == undefined ? "normal" : this.currentState;
		let btnImageUrl =
			this.currentState == "normal"
				? this.buttonData.icon
				: this.buttonData.icon.replace(".png", "") + this.currentState + ".png";
		this.el.style.backgroundImage = "url(" + btnImageUrl + ")";
		this.el.style.backgroundColor = this.bgColor;
		this.el.style.width = this.buttonData.width
			? this.buttonData.width
			: "100%";
		this.el.style.height = this.buttonData.height
			? this.buttonData.height
			: "100%";
		// this.renderer.setElementStyle(this.elementRef.nativeElement, 'disabled', this.disabled.toString()  );
	}

	@HostListener("mouseover") onMouseEnter() {
		if (this.useMouseAction == undefined || this.useMouseAction == true) {
			this.changeBg(this.currentState === "_visited" ? "_hover" : "_hover");
		}
	}
	@HostListener("mouseout") onMouseLeave() {
		if (this.useMouseAction == undefined || this.useMouseAction == true) {
			this.changeBg(
				this.currentState === "_active"
					? "_active"
					: this.currentState === "_visited"
					? "_visited"
					: "normal"
			);
		}
	}

	@HostListener("click", ["$event"]) onClick() {
		this.currentState = "_active";
		this.changeBg(this.currentState);
		this.buttonclick.emit(null);
	}
	private changeBg(buttonState) {
		if (!this.el) return;
		let strBgpath: string = this.buttonData.icon;
		if (buttonState != "normal") {
			strBgpath = strBgpath.substr(0, strBgpath.length - 4);
			strBgpath = strBgpath + buttonState + ".png";
		}
		this.el.style.backgroundImage = "url(" + strBgpath + ")";
	}
}
